module.exports = __webpack_public_path__ + "img/details-product-mob.c9105db.webp";